import React from "react";
import { Layout } from "antd";
import { connect, useDispatch, useSelector } from "react-redux";
import UserInfo from "components/UserInfo";
import TenantIndex from "../index";
import Screen from "../../../util/Extensions/Screens";
import { Link } from "react-router-dom";
import {
  switchLanguage,
  toggleCollapsedSideNav,
} from "../../../appRedux/actions/Setting";
import { useMediaQuery } from "react-responsive";
import AppNotification from "components/AppNotification";
import config from "util/ApiforContext";

const { Header } = Layout;

const InsideHeader = () => {
  const dispatch = useDispatch();

  const navCollapsed = useSelector(({ settings }) => settings.navCollapsed);

  return (
    <div className="gx-header-horizontal gx-header-horizontal-dark gx-inside-header-horizontal">
      <Header
        style={{ backgroundColor: "transparent" }}
        className="gx-header-horizontal-main"
      >
        <div className="gx-container">
          <div className="gx-header-horizontal-main-flex">
            <div className="gx-linebar gx-mr-xs-3">
              <i
                className="gx-icon-btn icon icon-menu"
                onClick={() => {
                  dispatch(toggleCollapsedSideNav(!navCollapsed));
                }}
              />
            </div>
            {Screen.screen === 0 ? (
              <Link to="/home" className="gx-pointer gx-mr-xs-3 gx-logo">
                <img alt="" style={{ width: 125 }} src={require("assets/images/koletralogo_white.png")} />
              </Link>
            ) : Screen.screen === 1 ? (
              <Link to="/home" className="gx-pointer gx-mr-xs-3 gx-logo">
                <img alt="paratic" title="imzapos" style={{ width: 125 }} src={require("assets/images/imzaposLogoBeyaz.png")} />
              </Link>
            ) : (
              <Link to="/home" className="gx-pointer gx-mr-xs-3 gx-logo">
                <img alt="paratic" title="Bakiyem" style={{ width: 125 }} src={require("assets/images/logoBakiyemWhite.png")} />
              </Link>
            )}
            <ul
              className="gx-header-notifications gx-ml-auto"
              style={{
                marginRight: useMediaQuery({
                  query: "(max-width: 980px)",
                })
                  ? 0
                  : -52,
                marginTop: -3,
              }}
            >
              {config.renderNotifications && (
                <li className="gx-notify">
                  <AppNotification />
                </li>
              )}
              <li>
                <UserInfo />
              </li>
              <li>
                <TenantIndex />
              </li>
            </ul>
          </div>
        </div>
      </Header>
    </div>
  );
};

const mapStateToProps = ({ settings }) => {
  const { locale, navCollapsed } = settings;
  return { locale, navCollapsed };
};
export default connect(mapStateToProps, {
  toggleCollapsedSideNav,
  switchLanguage,
})(InsideHeader);
